module.exports = __webpack_public_path__ + "img/ps-rec-img.00ac6349.svg";